import styled from "styled-components";

export const BackgroundContainer = styled.div`
  background: white;
  border-radius: 10px;
  height: max-content;
  zindex: 81;
  position: absolute;
  margin: auto 0;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0px 23px 0px;
  row-gap: 8px;
  transform: translate(-50%, -2%);

  @media screen and (min-width: 280px) and (max-width: 550px) {
    width: 85vw;
  }

  @media screen and (min-width: 551px) and (max-width: 768px) {
    width: 70vw;
  }

  @media screen and (min-width: 769px) and (max-width: 869px) {
    width: 60vw;
  }
  @media screen and (min-width: 870px) and (max-width: 969px) {
    width: 50vw;
  }
  @media screen and (min-width: 970px) and (max-width: 1069px) {
    width: 45vw;
  }
  @media screen and (min-width: 1070px) and (max-width: 1369px) {
    width: 35vw;
  }
  @media screen and (min-width: 1370px) and (max-width: 1679px) {
    width: 30vw;
  }
  @media screen and (min-width: 1680px) {
    width: 25vw;
  }
`;

export const AliasMessageLabel = styled.label`
  color: #86868d;
  height: max-content;
  place-items: center;
  text-align: left;
  font-size: 4vw;
  @media screen and (min-width: 563px) and (max-width: 1115px) {
    font-size: 1.1rem;
  }

  @media screen and (min-width: 1116px) and (max-width: 1437px) {
    font-size: 1.2rem;
  }
  @media screen and (min-width: 1438px) and (max-width: 1593px) {
    font-size: 1.2rem;
  }

  @media screen and (min-width: 1594px) {
    font-size: 1.2rem;
  }
`;

export const OnBackgroundDiv = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: black;
  display: grid;
  placecontent: center;
  top: 0;
  position: fixed;
`;
